/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { isValidGuid } from "utils/empty-exists";

export const generateImageSlide = async (images, token) => {
    
    const imageSlides = await Promise.all(
        images.filter((data) => isValidGuid(data?.image))
            .map(async (data) => {
                const image = await SimpliCityAdminSDK.images.findOne(token, data?.image);
                return {
                    src: image?.url,
                    width: image?.width || 1920,
                    height: image?.height || 1080,
                    title: image?.title,
                    description: image?.caption ? image?.caption : image?.alt,
                };
            })
    );
    return imageSlides;
};

export const IMAGE_GALLERY_TYPES = {
    FILMSTRIP: "thumbnail",
    CAROUSEL: "slider",
    GRID: "grid",
    COLLAGE: "masonry",
};
